<div
  [hidden]="isLoading"
  class="box-shadow rounded--large guts-p-t-2 guts-p-b-0 guts-p-h-2"
>
  <div class="l_flexbar">
    <h1 class="h3 l_flex-grow" [innerHtml]="chartName"></h1>
  </div>
  <div class="l_flexbar_grow guts-m-b-1">
    <div class="l_flex">
      <p
        *ngIf="subtitle"
        class="par par--light par--small"
        [innerHtml]="subtitle"
      ></p>
    </div>
    <div class="l_flex">
      <p
        *ngIf="countStringFormatted"
        class="par par--light par--small"
        [innerHtml]="countStringFormatted"
      ></p>
    </div>
  </div>
  <div id="highcharts" class="highcharts guts-m-b-0"></div>
</div>

<div *ngIf="isLoading">
  <dgx-skeleton type="opportunity"></dgx-skeleton>
</div>
